export default {
  namespaced: true,
  ai_analytics_servers: {
    title: "Servidores de análisis de IA",
    servers: "Servidores",
    server: "Servidor",
    server_name: "Nombre del Servidor",
    service_name: "Nombre del Servicio",
    host: "Host",
    limit: "Límite",
    online: "En Línea",
    offline: "Fuera de Línea",
    id_tenant: "ID del Tenant",
    devices: "Dispositivos",
    device: "Dispositivo",
    device_name: "Nombre del Dispositivo",
    url: "URL",
    devices_count: "Cantidad de Dispositivos",
    number_of_devices: "Número de Dispositivos",
    maximum_devices: "Dispositivos Máximos",
    on_server_status: "Estado en Servidor",
    message: "Mensaje",
    camera: "Cámara",
    created_at: "Fecha de Creación",
    server_id: "ID del Servidor",
    server_uuid: "UUID del Servidor",
    logs: "Registros",
    id: "ID",
    uuid: "UUID",
    tenant: "Tenant",
    status_active: "Estado Activo",
    cameras_online: "Cámaras en Línea",
    start_date: "Fecha de Inicio",
    end_date: "Fecha de Fin",
    fire_threshold: "Umbral de Fuego",
    smoke_threshold: "Umbral de Humo",
    use_local_confirmation: "Inferencia Local",
    restart_server: "Reiniciar Servidor",
    restart_confirmation_title: "¿Reiniciar servidor?",
    restart_confirmation_body: "El servidor {serverName} se reiniciará.",
    uuid_not_found: "UUID del servidor no encontrado",
    restarted_successfully: "Servidor reiniciado correctamente",
    restart_error: "Error al reiniciar el servidor",
    fetch_error: "Error obteniendo la información",
    delete_error: "Error al eliminar",
    update_status_error: "Error al actualizar el estado",
    STREAM_ONLINE: "Stream en línea y funcionando correctamente.",
    STREAM_CONNECTION_LOST: "Problemas de conexión en el stream: intermitencia o pérdida de frames.",
    STREAM_HARD_DOWN: "Stream caído y no se pudo recuperar.",
    STREAM_LOW_QUALITY: "Baja calidad del stream: bitrate insuficiente, baja resolución o pérdida de paquetes.",
    AUTH_ERROR: "Token RTSP inválido.",
    restart: 'Reiniciar',
    server_type: "Tipo de servidor"
  },
};
